import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "initials",
})
export class InitialsPipe implements PipeTransform {
  transform(firstName?: string | null, lastName?: string | null): string {
    const first = firstName?.trim();
    const last = lastName?.trim();

    if (!first && !last) {
      return "?";
    }

    if (first && last) {
      return (first[0] + last[0]).toUpperCase();
    }

    return (first ?? last)![0].toUpperCase();
  }
}
